import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { HeaderSimple } from '../_common';

const sizeMap = {
  small: 400,
  medium: 800,
  large: '100%',
};

export default function CompactLayout({ size = 'small', title, disabled, children }) {
  const maxWidth = sizeMap[size];

  return (
    <>
      <HeaderSimple title={title} disabled={disabled} />

      <Container component="main">
        <Stack sx={{ py: 16, m: 'auto', maxWidth, minHeight: '100vh', textAlign: 'center' }}>
          {children}
        </Stack>
      </Container>
    </>
  );
}

CompactLayout.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  title: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};
